import React from 'react';
import {Row, Modal, Typography} from 'antd'

import constant from '../../../../constants/constant'
import LicenseResult from "../../../License/LicenseResult";
import typo from '../../../../constants/dictionaries'
import Organization from "../../../License/Organization";

const {Text, Title} = Typography;

const LicenseModal = ({initialValues, handleCancel}) => {
  const {loaiCongTrinh} = initialValues;

  return (
    <Row>
      <Modal
        title="Thông tin chi tiết giấy phép"
        centered
        closable={true}
        visible={true}
        width="50%"
        footer={null}
        onCancel={handleCancel}>
        <a>{typo.cscore_license_organization}</a>
        <Organization data={initialValues}/>
        <Row className="mt-20"/>
        <a>{typo.cscore_license}</a>
        <LicenseResult data={initialValues}/>
      </Modal>
    </Row>
  )
};

export default LicenseModal